import { Breadcrumbs, Grid, Link } from "@mui/material";
import React from "react";
import reports from "../../images/reports.svg"
import analytics from "../../images/analytics.svg"
import { useNavigate } from "react-router-dom";
import Styles from "../../layouts/PMSComponents/Styles/main.module.css";
import moduleLayoutStyles from "../../layouts/CommonLayouts/Styles/moduleLayout.module.css";
import { ls } from "../../variables";
import { useStateValue } from "../../Hooks/stateProvider";

const ReportGenModule = (props) => {

  const userType = ls.get("userType");
  // console.log("user type quicksight",userType)
  const navigate = useNavigate();
  const [state, dispatch] = useStateValue();
  let onHandler = (value) => {
    navigate(value);
  };
  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Grid container spacing={1} display="flex">
            <Grid item sm={12}>
              <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
                {/* {userType == "APMII" && <Link
                  underline="hover"
                  color="inherit"
                  onClick={props.type === "quicksight" ? () => navigate("/app/welcome") : undefined}
                >
                  Welcome
                </Link>} */}
                <Link
                  underline="hover"
                  color="inherit"
                >
                  {props.type == "quicksight" ? "Report Generator Module" : "HYTR"}
                </Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </div>
        <div className={Styles.HeaderBody}>
          <Grid container className={moduleLayoutStyles.mainContent}>
            <Grid
              item
              xs={12}
              className={moduleLayoutStyles.welcomeContent}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></Grid>
            <Grid item xs={0} sm={2}></Grid>
            <Grid
              item
              lg={4}
              xs={12}
              sm={4}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch({ type: "uploadType", uploadType: "File" });
                props.type == "ctr"
                  ? onHandler("/app/ctrPage")
                  : onHandler("/app/Analytics");
              }}
            >
              <div className={moduleLayoutStyles.boxContainer}>
                <img src={analytics} alt="AnalyticsLogo" className={moduleLayoutStyles.moduleImg} />
                <h3 className={moduleLayoutStyles.moduleName}>Analytics</h3>
              </div>
            </Grid>

            <Grid
              item
              lg={4}
              xs={12}
              sm={4}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch({ type: "uploadType", uploadType: "Form" });
                props.type == "ctr"
                  ? onHandler("/app/ctrPage")
                  : onHandler("/app/Reports");
              }}
            >
              <div className={moduleLayoutStyles.boxContainer}>
                <img src={reports} alt="Report Logo" className={moduleLayoutStyles.moduleImg} />
                <h3 className={moduleLayoutStyles.moduleName}>Reports</h3>
              </div>
            </Grid>
            <Grid item xs={0} sm={2}></Grid>

          </Grid>
        </div>
      </div>
    </>
  )
};


export default ReportGenModule;